import React from 'react';
import { Alert, Button, Space } from 'antd';
import { formatMoney } from '@/utils/format';

type Props = {
  estimateLabel: string;
  costDelta?: number | null;
  onReview: () => void;
};

export function QuotationEstimateChangeBanner({ estimateLabel, costDelta, onReview }: Props) {
  return (
    <Alert
      type="warning"
      showIcon
      message="New estimate revision available"
      description={
        <Space direction="vertical" size={4}>
          <span>
            {estimateLabel}
            {costDelta != null ? (
              <>
                {' '}
                — cost impact{' '}
                <strong>
                  {costDelta >= 0 ? '+' : ''}
                  {formatMoney(costDelta)}
                </strong>
              </>
            ) : null}
          </span>
          <Button size="small" type="primary" onClick={onReview}>
            Review Changes
          </Button>
        </Space>
      }
    />
  );
}
